module.exports = __webpack_public_path__ + "img/bg-arrow.4495810b.svg";